import { Atom } from 'AppReact';
import styled, { css } from 'styled-components';

const template = styled.span`
  ${({ theme, displayState }) => css`
    max-width: 250px;
    min-width: ${displayState?.minWidth ?? "200px"};
    position: absolute;
    padding: 10px;
    top: 100%;
    z-index: 10;
    left: 50%;
    -webkit-transform: translateX(-50%);
    transform: translateX(-50%);
    text-align: center;
    background: ${`${theme?.colour?.secondary}E6`};
    color: white;
    font-size: 12px;
    white-space: ${displayState?.whiteSpace ?? 'pre-wrap'};
    border-radius: 8px;

    ${displayState?.direction === 'right' && css`
      left: 100%;
      top: 50%;
      transform: translateX(0) translateY(-50%);
    `}

    ${displayState?.direction === 'left' && css`
      left: auto;
      right: 100%;
      transform: translateX(0) translateY(50%);
    `}

    ${displayState?.breakWord && css`
      word-wrap: break-word;
      overflow-wrap: break-word;
    `}
  `}
`;

export default Atom({ type: 'label', dataType: 'string', template })